import $ from 'jquery';
import * as api from './api';
import * as tips from './tips';
import { checkReserveStatus } from './reserve';
import * as utils from './utils';
let canClick = true;
let timer = null;
let targetAwardIndex = 9;
let lotteryTime = 0;
$('.j-jumpToLottery').on('click', () => {
  $('.j-popup').fadeOut(500);
  $('.j-lottery-popup').fadeIn(800);
});
const reset = () => {
  for (let i = 0; i < 10; i++) {
    $('.j-item-' + i).removeClass('active');
  }
};
const getAllClassName = () => {
  let res = '';
  for (let key = 0; key < 10; key++) {
    res += 'award-' + (key + 1) + ' ';
  }
  return res;
};
const updateLotteryRes = data => {
  clearTimeout(timer);
  reset();
  targetAwardIndex = data.gift_key - 1;
  $('.j-item-' + targetAwardIndex).addClass('active');
  $('.j-award-pic')
    .removeClass(getAllClassName())
    .addClass(`award-${data.gift_key}`);
  $('.j-count').html(data.lotteryChance);
  $('.j-lottery-res-popup').fadeIn(500);
  canClick = true;
};
const startLotteryAnimate = () => {
  let lastIndex = -1;
  let index = -1;
  timer = setInterval(() => {
    index = Math.floor(Math.random() * 10);
    lastIndex === index && (index < 9 ? index++ : index--);
    lastIndex = index;
    reset();
    $('.j-item-' + index).addClass('active');
    lotteryTime += 150;
  }, 150);
};

$('.j-lottery-btn').on('click', async function () {
  // 结束
  tips.alert('','活動已結束');
  return;
  if (!checkReserveStatus()) {
    $('.j-reserve-popup').fadeIn(400);
    tips.alert('reserveNeed');
    return;
  }
  if (!~~$('.j-count').html()) {
    $('.lottery-chance-popup').fadeIn(400);
    return;
  }
  if (!canClick) return;
  canClick = false;
  startLotteryAnimate();
  let lotteryRes = await api.lottery();
  if (+lotteryRes.code !== 1) {
    tips.alert('', lotteryRes.msg);
    canClick = true;
    return;
  }
  await utils.sleep(2);
  updateLotteryRes(lotteryRes.data);
});
